import gql from 'graphql-tag';

export const UPDATE_BUBBLE_TEXT = gql`
  mutation updateBubbleText(
    $bubbleTextId: Int!
    $text: String!
    $angle: Decimal!
    $xAxis: Int!
    $yAxis: Int!
    $width: Int!
    $shape: EBubbleShape!
    $tailType: EBubbleTail!
    $characterId: Int
    $assetId: String!
    $hasShadow: Boolean!
  ) {
    bubbleText {
      update(
        bubbleTextId: $bubbleTextId
        request: {
          text: $text
          angle: $angle
          x: $xAxis
          y: $yAxis
          w: $width
          shape: $shape
          tailType: $tailType
          characterId: $characterId
          assetId: $assetId
          hasShadow: $hasShadow
        }
      ) {
        id
        text
        angle
        x
        y
        w
        shape
        tailType
        isTailVisible
        hasShadow
        assetId
        characterId
        character {
          name
          id
        }
      }
    }
  }
`;
